import React from 'react';
import './EmbedSlideContent.scss';

const EmbedSlideContent = ({ slide }) => {
    return <div className="embed-slide">
        <iframe src={slide.video.url} allow="encrypted-media; geolocation" allowFullScreen={true} frameBorder="0"></iframe>
    </div>
}
export default EmbedSlideContent;
